// Mock data for Dentcraft NSW - Paintless Dent Repair (frontend-only)

export const business = {
  name: "Dentcraft NSW",
  tagline: "The Paintless Dent Removal Experts",
  subtitle: "Servicing West Sydney and Sydney Metro",
  phone: "0474 020 202",
  phoneRaw: "0474020202",
  email: "info@dentcraftnsw.com.au",
  address: "PO Box 117, Georges Hall, NSW, Australia, 2198",
  owner: "Sam Elmasri",
  facebook: "https://facebook.com",
};

export const heroSlides = [
  {
    image:
      "https://images.unsplash.com/photo-1508974576580-36a2f92ad3bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxnbG9zc3klMjBjYXIlMjBwYWludHxlbnwwfHx8fDE3ODgyNDc0NDZ8MA&ixlib=rb-4.1.0&q=85",
    title: "Paintless Dent Removal",
    sub: "Restoring your factory finish, on-site",
  },
  {
    image:
      "https://images.unsplash.com/photo-1616591938558-fb03d845567b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxwcmVzdGlnZSUyMGF1dG9tb2JpbGV8ZW58MHx8fHwxNzg4MjQ3NDQ2fDA&ixlib=rb-4.1.0&q=85",
    title: "Prestige & Classic Cars",
    sub: "Trained in Germany & Australia",
  },
  {
    image:
      "https://images.unsplash.com/photo-1518306727298-4c17e1bf6942?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxnbG9zc3klMjBjYXIlMjBwYWludHxlbnwwfHx8fDE3ODgyNDc0NDZ8MA&ixlib=rb-4.1.0&q=85",
    title: "Hail Damage Specialists",
    sub: "Fast, mobile, same-day service",
  },
  {
    image:
      "https://images.pexels.com/photos/20131971/pexels-photo-20131971.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Mobile On-Site Repairs",
    sub: "We come to your home or workplace",
  },
];

export const features = [
  "PDR repairs at your home or workplace",
  "From small panel dents to full car restorations",
  "Servicing all areas of West Sydney and Sydney Metro",
  "On-the-spot estimates over the phone",
  "No costly panel beating and paint repairs",
  "Hail damage repair specialists",
  "Mobile onsite repairs and same-day service",
  "Honest advice and fast friendly service",
];

export const services = [
  {
    id: "locations",
    title: "Our Service Locations",
    image:
      "https://images.unsplash.com/photo-1564705604144-51593412c133?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    short:
      "We come to your home or office across Sydney — Canterbury, Liverpool, Blacktown and Penrith.",
    long:
      "Dentcraft NSW is a fully mobile service. We travel to your home or workplace throughout West Sydney and the wider Sydney Metro area, including Canterbury, Liverpool, Blacktown and Penrith. No need to drop your car anywhere — we bring the workshop to you.",
    icon: "MapPin",
  },
  {
    id: "quotes",
    title: "Easy Instant Quotes",
    image:
      "https://images.unsplash.com/photo-1503526546671-31d62290e7e3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    short:
      "Take a photo of your dent and text Sam to get an on-the-spot estimate of your repair.",
    long:
      "Getting a quote couldn't be simpler. Snap a photo of your dent and text it to Sam on 0474 020 202 with a short description. You'll receive an accurate, on-the-spot estimate the same day — no obligation, completely free.",
    icon: "Smartphone",
  },
  {
    id: "hail",
    title: "Hail Damage Repairs",
    image:
      "https://images.unsplash.com/photo-1561138814-a1f83c5f4ac7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    short:
      "Has your car been hit by hail? Dentcraft NSW restores your car to its original condition.",
    long:
      "Hail storms can leave hundreds of small dents across your bonnet, roof and boot. Using specialist PDR techniques, we gently massage each dent back to shape — preserving your factory paint and saving you thousands over conventional repairs.",
    icon: "CloudHail",
  },
  {
    id: "satisfaction",
    title: "100% Satisfaction",
    image:
      "https://images.unsplash.com/photo-1604447199408-9798f9f64f88?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    short:
      "Our skilled team repairs your car with dedication and care. Specialising in prestige vehicles.",
    long:
      "We pride ourselves on 100% satisfaction and honesty. Recommended by all major insurance companies, fully licensed and insured, we treat every vehicle — from daily drivers to prestige cars — with meticulous care.",
    icon: "BadgeCheck",
  },
];

export const process = [
  {
    step: "01",
    title: "Send a Photo",
    text: "Text a photo of the damage to Sam for a free, on-the-spot estimate.",
    icon: "Camera",
  },
  {
    step: "02",
    title: "Book a Time",
    text: "We arrange a convenient time to come to your home or workplace.",
    icon: "CalendarClock",
  },
  {
    step: "03",
    title: "Precision PDR",
    text: "Dents are gently massaged out from behind the panel — no filler, no paint.",
    icon: "Wrench",
  },
  {
    step: "04",
    title: "Factory Finish",
    text: "Your car is restored to its original factory finish, good as new.",
    icon: "Sparkles",
  },
];

export const benefits = [
  {
    title: "Keeps Factory Paint",
    text: "PDR preserves your original paintwork — no colour matching, no respray.",
    icon: "Paintbrush",
  },
  {
    title: "Saves You Money",
    text: "A fraction of the cost of traditional panel beating and paint repairs.",
    icon: "PiggyBank",
  },
  {
    title: "Fast Turnaround",
    text: "Most repairs take minutes to hours, not days in a body shop.",
    icon: "Timer",
  },
  {
    title: "Retains Value",
    text: "Original paint and panels keep your vehicle's resale value high.",
    icon: "TrendingUp",
  },
];

export const gallery = [
  {
    image:
      "https://images.unsplash.com/photo-1780586585338-c56fe47b49f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Bonnet Restoration",
    category: "Hail Damage",
  },
  {
    image:
      "https://images.unsplash.com/photo-1705443990676-c94a1005898c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Rear Fender Repair",
    category: "Door Ding",
  },
  {
    image:
      "https://images.unsplash.com/photo-1564705604144-51593412c133?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Door Panel Ding",
    category: "Door Ding",
  },
  {
    image:
      "https://images.unsplash.com/photo-1769641241077-fa1528ac2068?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Fuel Door Detail",
    category: "Prestige",
  },
  {
    image:
      "https://images.unsplash.com/photo-1568831898760-a1031df598dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Prestige Panel Work",
    category: "Prestige",
  },
  {
    image:
      "https://images.unsplash.com/photo-1601673631112-4c8b4e2ab37c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Full Panel Restoration",
    category: "Restoration",
  },
  {
    image:
      "https://images.unsplash.com/photo-1550565076-b2371ea1a324?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Quarter Panel Dent",
    category: "Door Ding",
  },
  {
    image:
      "https://images.unsplash.com/photo-1616591938558-fb03d845567b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Sports Car Detail",
    category: "Prestige",
  },
];

export const testimonials = [
  {
    name: "Michael T.",
    location: "Liverpool",
    text: "Sam came to my work and removed three door dings in under an hour. You honestly can't tell they were ever there. Brilliant service.",
    rating: 5,
  },
  {
    name: "Rebecca H.",
    location: "Penrith",
    text: "After the hail storm my car was covered in dents. Dentcraft restored it perfectly and saved me a fortune on my insurance excess. Highly recommend.",
    rating: 5,
  },
  {
    name: "David K.",
    location: "Blacktown",
    text: "Prestige car owner here — I was nervous, but Sam's work is flawless. Factory finish, no paint, done at my home. Top professional.",
    rating: 5,
  },
];

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Paintless Dent Removal", path: "/paintless-dent-removal" },
  { label: "Our Services", path: "/our-services" },
  { label: "Repairs Gallery", path: "/repairs-gallery" },
  { label: "Contact Us", path: "/contact" },
];
